import { useContext } from 'react';
import { FormUtilsContext } from '../FormUtilsContext';

export const useFormUtilsContext = () => {
  const formUtils = useContext(FormUtilsContext);
  return formUtils;
};